import { resetExerciseSubmissions } from '../../ExerciseSubmissions';
import { resetMessages } from '../../Messages';
import { resetNursePractitioner } from '../../NursePractitioner';
import { resetRegistrations } from '../../Registrations';
import { viewReset } from '../View';

export const USER_RESET = 'USER_RESET';
export function userReset() {
  return {
    type: USER_RESET,
  };
}

export function resetUserData() {
  return (dispatch) => {
    dispatch(userReset());
    dispatch(resetExerciseSubmissions());
    dispatch(resetMessages());
    dispatch(resetNursePractitioner());
    dispatch(resetRegistrations());
    dispatch(viewReset('diary_overview'));
  };
}
